const mockDate = (min = 0, max = 365) => {
  const dayInMilliseconds = 1000 * 60 * 60 * 24;
  return Math.floor(
    new Date() - dayInMilliseconds * (Math.random() * (max - min) + min)
  );
};

export { mockDate };
